import CustomApprovalModal from "@/shared/components/custom-modal";
import { ReactNode } from "react";

interface OrderHistoryInfoBaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title: string;
  body: ReactNode;
  cancelName?: string;
  confirmName?: string;
  confirmBtnBgColor?: string;
}

const OrderHistoryInfoBaseModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  body,
  cancelName = "닫기",
  confirmName = "확인",
  confirmBtnBgColor,
}: OrderHistoryInfoBaseModalProps) => {
  return (
    <CustomApprovalModal isOpen={isOpen} onClose={onClose}>
      <CustomApprovalModal.Header title={title} onClose={onClose} />
      <CustomApprovalModal.Body>{body}</CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        cancelName={cancelName}
        confirmName={confirmName}
        onCancel={onClose}
        onConfirm={onConfirm}
        isLoading={isLoading}
        confirmBtnBgColor={confirmBtnBgColor}
      />
    </CustomApprovalModal>
  );
};

export default OrderHistoryInfoBaseModal;
